import { z } from 'zod'
import { baseSchema } from './base'

export const formSchema = baseSchema.extend({
  type: z.literal('form'),
  name: z.string().optional(),
  preserve: z.boolean().optional(),
  fields: z.any().array().optional().describe('表单项配置'),
  initialValues: z.record(z.string(), z.any()).optional().describe('设置表单的初始值'),
  layout: z
    .union([z.literal('horizontal'), z.literal('inline'), z.literal('vertical')])
    .default('horizontal')
    .describe('表单布局'),
  labelWidth: z
    .union([z.number(), z.string()])
    .optional()
    .describe('标签宽度，当为数字时表示在 24 列的栅格中占据多少列，当为 string 时使用 flex 布局'),
  labelAlign: z.enum(['left', 'right']).optional().describe('标签对齐方式'),
  clearOnDestroy: z.boolean().optional().describe('当表单被卸载时清空表单值'),
  gutter: z
    .union([
      z.number().describe('横向间隔'),
      z.tuple([z.number().describe('横向间隔'), z.number().describe('纵向间隔')]),
    ])
    .default(10)
    .describe('Grid 栅格间隔'),
})

export type FormSchema = z.infer<typeof formSchema>
